import jump from 'jump.js';

export function j(element) {
    jump(element, {
        duration: 1100,
        offset: 0,
        callback: undefined,
        easing: (t, b, c, d) => {
                t /= d / 2
                if (t < 1) return c / 2 * t * t + b
                t--
                return -c / 2 * (t * (t - 2) - 1) + b
            },
        a11y: false
    }); 
}